
const colors = {
  primary: '#0038FF',
  primaryLighter: '#cff97a',
  textColor: '#ffffff',
  textColorSecondary: '#a4b1cd',
  background: '#141d2b',
  backgroundDarker: '#111927',
  backgroundLighter: '#1a2332',
  bgShadowColor: '#0f1620',
  fgShadowColor: '#2f73ca',
  primaryTransparent: '#9fef0012',

  // Action Colors
  info: '#04e4f4',
  success: '#20e253',
  warning: '#f6f000',
  error: '#fca016',
  danger: '#f80363',
  neutral: '#272f4d',
};

export default colors;
